import { environment } from '../../environments/environment';

class ApiUrl {
	static paths = {
		searchTransaction: 'SearchTransaction',
		newLinkOperation: 'newlinkoperation',
		transactions: 'transactions',
		empresasList: 'empresas-list',
		endpointCount: 'endpointcount',
		oSearch: 'osearch',
		doSearch: 'dosearch',
		validar: 'validar',
		operations: 'ResponseOBDList',
		accounts: 'accounts',
		login: 'login',
		signPdf: 'sign-pdf',
		api: 'api',
		conjuntoImg: 'conjuntoimg',
		clientConfig: 'clientconfig',
		update: 'update',
		empresaConfig: 'empresaconfig'
	};
}

export class UrlFactory {
	private static apiUrl: string = environment.API_URL;

	static login(): string {
		return `${this.apiUrl}/${ApiUrl.paths.accounts}/${ApiUrl.paths.login}`;
	}

	static postNewLinkOperation(): string {
		return `${this.apiUrl}/${ApiUrl.paths.api}/${ApiUrl.paths.newLinkOperation}/`;
	}
	static postSearchTransaction(): string {
		return `${this.apiUrl}/${ApiUrl.paths.api}/${ApiUrl.paths.searchTransaction}/`;
	}

	static getReports(): string {
		return `${this.apiUrl}/${ApiUrl.paths.api}/${ApiUrl.paths.transactions}2/`;
	}

	static getCustomers(): string {
		return `${this.apiUrl}/${ApiUrl.paths.api}/${ApiUrl.paths.empresasList}/`;
	}

	static postStats(): string {
		return `${this.apiUrl}/${ApiUrl.paths.api}/${ApiUrl.paths.endpointCount}/`;
	}

	static postOsearch(): string {
		return `${this.apiUrl}/${ApiUrl.paths.api}/${ApiUrl.paths.oSearch}/`;
	}

	static postDoSearch(): string {
		return `${this.apiUrl}/${ApiUrl.paths.api}/${ApiUrl.paths.doSearch}/`;
	}

	static postValidar(): string {
		return `${this.apiUrl}/${ApiUrl.paths.api}/${ApiUrl.paths.validar}/`;
	}

	static getOperations(): string {
		return `${this.apiUrl}/${ApiUrl.paths.api}/${ApiUrl.paths.operations}/`;
	}

	static getImages(colectionImageId: number): string {
		return `${this.apiUrl}/${ApiUrl.paths.api}/${ApiUrl.paths.conjuntoImg}/${colectionImageId}`;
	}

	static getGeneralAndControlConfigurations(): string {
		return `${this.apiUrl}/${ApiUrl.paths.api}/${ApiUrl.paths.clientConfig}/`;
	}

	static saveGeneralAndControlConfigurations(idEmpresa: number): string {
		return `${this.apiUrl}/${ApiUrl.paths.api}/${ApiUrl.paths.clientConfig}/${idEmpresa}/${ApiUrl.paths.update}/`;
	}

	static getAdvancedConfiguration(): string {
		return `${this.apiUrl}/${ApiUrl.paths.api}/${ApiUrl.paths.empresaConfig}/`;
	}

	static saveAdvancedConfiguration(idEmpresa: number): string {
		return `${this.apiUrl}/${ApiUrl.paths.api}/${ApiUrl.paths.empresaConfig}/${idEmpresa}/${ApiUrl.paths.update}/`;
	}
}
